/**
 * The knowledge bases an agent can search, for the Account Settings Knowledge tab.
 * Served by the Gateway (GET /channels/portal/knowledge-bases), which returns only
 * the agents the user may use (403 otherwise).
 */
import { gatewayClient } from '../../client/GatewayClient';
import type { Locale } from '../../i18n/resources';

export type SyncStatus = 'succeeded' | 'syncing' | 'failed';

export interface LocalizedText {
  zh?: string;
  en?: string;
}

export interface KnowledgeBase {
  /** Logical name, e.g. "creditadvisor"; also the last-resort display name. */
  name: string;
  displayName: LocalizedText;
  description: LocalizedText;
  /** The latest ingestion job; null when the KB has never synced or its status is unavailable. */
  sync: { status: SyncStatus; updatedAt: string; documents?: number | null } | null;
}

export async function listKnowledgeBases(agent: string): Promise<KnowledgeBase[]> {
  const resp = await gatewayClient.get<{ items?: KnowledgeBase[] }>('/channels/portal/knowledge-bases', { agent });
  return resp.items ?? [];
}

/** The text for the UI locale, else the other language, else `fallback`. */
export function pickText(text: LocalizedText | undefined, locale: Locale, fallback = ''): string {
  const other: Locale = locale === 'en' ? 'zh' : 'en';
  return text?.[locale]?.trim() || text?.[other]?.trim() || fallback;
}
